import { theme } from "../../theme.js";

export default function Section({ children, title, border = true, headerAction, style }) {
    return (
        <section style={{...styles(theme, border).section, ...style}}>
            {title !== null && (
                <div style={styles(theme, border).header}>
                    <h2 style={styles(theme, border).sectionTitle}>{title}</h2>
                    {headerAction}
                </div>
            )}
          <div style={styles(theme, border).content}>
              {children}
          </div>
        </section>
    );
}

const styles = (theme, border) => ({
    section: {
    padding : `${theme.spacing.xl} 0`,
    borderBottom: border ? `1px solid ${theme.colors.border}` : "none",
    paddingBottom: theme.spacing.xxxl,
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: theme.spacing.xxl,
    gap: theme.spacing.lg,
  },
  sectionTitle: {
    fontSize: theme.fonts.size.xl,
    fontWeight: theme.fonts.weight.bold,
    color: theme.colors.textInverted,
    margin: 0,
    fontFamily: theme.fonts.family.primary,
  },
  content: {
    display: "flex",
    flexWrap: "wrap",    
    gap: theme.spacing.md,
    width: "100%",
  },
})
